import { BrowserModule } from '@angular/platform-browser';
import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { AppComponent } from './app.component';
import { AppRoutingModule } from './app-routing.module';
import { ImportFileComponent } from './import-file/import-file.component';
import { MainComponent } from './main/main.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { DisplayImagesFromFileComponent } from './display-images-from-file/display-images-from-file.component';
import { FlexLayoutModule } from '@angular/flex-layout';
import { ImageFromFileComponent } from './image-from-file/image-from-file.component';
import { MainHeaderComponent } from './main-header/main-header.component';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { HttpClientModule } from '@angular/common/http';
import { DialogFileGettingReadyComponent } from './dialog-file-getting-ready/dialog-file-getting-ready.component';
import { DialogStartComponent } from './dialog-start/dialog-start.component';
import { MakeOerComponent } from './make-oer/make-oer.component';
import { DialogWarningImagesRatioMismatchComponent } from './dialog-warning-images-ratio-mismatch/dialog-warning-images-ratio-mismatch.component';
import { ScrollingModule } from '@angular/cdk/scrolling';
import { ImageFromOnlineSearchComponent } from './image-from-online-search/image-from-online-search.component';
import { DialogEditImageComponent } from './compare-images/dialog-edit-image/dialog-edit-image.component';
import { SearchDatabaseForOccurencesComponent } from './search-database-for-occurences/search-database-for-occurences.component';
import { DialogSuggestionsFromDatabaseComponent } from './dialog-suggestions-from-database/dialog-suggestions-from-database.component';
import { CompareImagesModule } from './compare-images/compare-images.module';
import { HeaderModule } from './header/header.module';
import { LoadingSpinnerModule } from './loading-spinner/loading-spinner.module';
import { ImageGalleryModule } from './image-gallery/image-gallery.module';
import { BottomSheetGenericComponent } from './bottom-sheet-generic/bottom-sheet-generic.component';
import { BottomSheetGenericModule } from './bottom-sheet-generic/bottom-sheet-generic.module';
import { SearchExternalApiModule } from './search-external-api/search-external-api.module';
import { OerFormularComponent } from './oer-formular/oer-formular.component';
import { ReplaceByImageFromMachineComponent } from './replace-by-image-from-machine/replace-by-image-from-machine.component';
import { DialogAskForFeedbackComponent } from './dialog-ask-for-feedback/dialog-ask-for-feedback.component';
import { FeedbackComponent } from './feedback/feedback.component';
import { ExcludeFromOverallLicenseComponent } from './exclude-from-overall-license/exclude-from-overall-license.component';
import { AdminAreaModule } from './admin-area/admin-area.module';
import { MatSliderModule } from '@angular/material/slider';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatDividerModule } from '@angular/material/divider';
import { MatRadioModule } from '@angular/material/radio';
import { ServiceWorkerModule } from '@angular/service-worker';
import { environment } from '../environments/environment';
import { DialogConfirmationComponent } from './dialog-confirmation/dialog-confirmation.component';
import { MatBottomSheetModule } from '@angular/material/bottom-sheet';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatNativeDateModule } from '@angular/material/core';
import { MatDialogModule } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatListModule } from '@angular/material/list';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatSelectModule } from '@angular/material/select';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { MatStepperModule } from '@angular/material/stepper';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatTabsModule } from '@angular/material/tabs';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { ActionViewerComponent } from './action-viewer/action-viewer.component';
import { UserConsentBottomSheet } from './user-consent/user-consent.component';
import { ImprintComponent } from './imprint/imprint.component';

@NgModule({
  declarations: [
    AppComponent,
    ImportFileComponent,
    MainComponent,
    DisplayImagesFromFileComponent,
    ImageFromFileComponent,
    MainHeaderComponent,
    DialogFileGettingReadyComponent,
    DialogStartComponent,
    MakeOerComponent,
    DialogWarningImagesRatioMismatchComponent,
    ImageFromOnlineSearchComponent,
    SearchDatabaseForOccurencesComponent,
    DialogSuggestionsFromDatabaseComponent,
    OerFormularComponent,
    ReplaceByImageFromMachineComponent,
    DialogAskForFeedbackComponent,
    FeedbackComponent,
    ExcludeFromOverallLicenseComponent,
    DialogConfirmationComponent,
    ActionViewerComponent,
    UserConsentBottomSheet,
    ImprintComponent,
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    BrowserAnimationsModule,
    MatSnackBarModule,
    MatInputModule,
    MatIconModule,
    FlexLayoutModule,
    MatButtonModule,
    MatToolbarModule,
    ReactiveFormsModule,
    HttpClientModule,
    MatSelectModule,
    MatDialogModule,
    MatProgressBarModule,
    MatTabsModule,
    ScrollingModule,
    MatStepperModule,
    MatExpansionModule,
    MatTooltipModule,
    CompareImagesModule,
    MatCardModule,
    MatBottomSheetModule,
    MatListModule,
    HeaderModule,
    LoadingSpinnerModule,
    ImageGalleryModule,
    BottomSheetGenericModule,
    SearchExternalApiModule,
    MatDatepickerModule,
    MatNativeDateModule,
    FormsModule,
    MatSliderModule,
    MatFormFieldModule,
    MatDividerModule,
    MatRadioModule,
    MatSlideToggleModule,
    ServiceWorkerModule.register('ngsw-worker.js', { enabled: environment.production }),
    AdminAreaModule,
    MatCheckboxModule,
  ],
  providers: [],
  bootstrap: [AppComponent],
  entryComponents: [
    DialogFileGettingReadyComponent,
    DialogStartComponent,
    DialogWarningImagesRatioMismatchComponent,
    DialogEditImageComponent,
    DialogSuggestionsFromDatabaseComponent,
    BottomSheetGenericComponent,
    DialogAskForFeedbackComponent,
    DialogConfirmationComponent
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class AppModule {}
